<div class="schedule-reminder-container">
  <div *ngIf="view === 'full'; else dayView">
    <app-schedule-reminder-full
      [reminders]="allReminders$ | async"
      [allRemindersLoaded]="allRemindersLoaded$ | async"
      [alerts]="alerts$ | async"
      (complete)="completeReminder($event)"
      (cancel)="cancelReminder($event)"
      (dismiss)="dismissAlert($event)"
      (create)="createNewReminder($event)"
      (reschedule)="rescheduleReminder($event)"
      (alert)="newReminderAlert($event)">
    </app-schedule-reminder-full>
  </div>
  <ng-template #dayView>
    <app-schedule-reminder-borrower
      [reminders]="allReminders$ | async"
      (newReminder)="createNewReminder($event)"
      (cancelReminder)="closeReminder()"
      (alert)="newReminderBorrowerAlert($event)">
    </app-schedule-reminder-borrower>
  </ng-template>
</div>
